import { render, staticRenderFns } from "./ClaimDelivery.vue?vue&type=template&id=4e51c688"
import script from "./ClaimDelivery.vue?vue&type=script&lang=js"
export * from "./ClaimDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports